import sdkInstanceProvider from "@src/client/sdk/sdkInstanceProvider";

const trackExperimentEvent = async (eventKey, eventTags = {}) => {
  const featuresSdk = await sdkInstanceProvider("features");

  featuresSdk.track(eventKey, null, null, eventTags);
};

export default trackExperimentEvent;
